import { t } from '@web/i18n';
import { AppIcons } from '@web/ui/core/atoms';

/** "Resumo da IA" above the conversation: the card's subject and summary. Nothing when both are empty. */
export function HandoffSummary({
  subject,
  summary,
}: Readonly<{ subject: string | null; summary: string | null }>): React.JSX.Element | null {
  if (!subject && !summary) return null;
  return (
    <div className="flex flex-col gap-1 border-b border-border-soft px-5 py-3">
      <div className="flex items-center gap-2">
        <AppIcons name="sparkle" size={14} className="text-faint-foreground" />
        <span className="font-mono text-tiny font-medium uppercase tracking-eyebrow-wide text-muted-foreground">
          {t('travelerView.summary.title')}
        </span>
      </div>
      {subject ? (
        <span className="text-card-title leading-card-title text-foreground">{subject}</span>
      ) : null}
      {summary ? (
        <p className="m-0 text-meta leading-snug text-muted-foreground">{summary}</p>
      ) : null}
    </div>
  );
}
